import {debug, error, warn} from "../../utils/log";
import type {createContext} from "../context-shared";
import {IPC_VERSION, URL_PREFIX} from "../../utils/constants";
import {exportConfig} from "../../utils/config";
import type {IStateStorage} from "../state";
import {later} from "../../utils/basic";

let channel: MessageChannel | undefined;
let iframe: HTMLIFrameElement | undefined;
let state: IStateStorage['state'] = 'initializing';

export async function setup(ctx: ReturnType<typeof createContext>) {
    try {
        return await new Promise<void>((resolve, reject) => {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = URL_PREFIX + 'bundle/iframe.html';
            iframe.setAttribute('aria-hidden', 'true');
            iframe.onload = () => {
                // Channel might be set when bfcache restore happens.
                if (channel) {
                    try {
                        channel.port1.close();
                        channel.port2.close();
                    } catch {}
                }
                channel = new MessageChannel()
                channel.port1.onmessage = (event) => {
                    const data = event.data;
                    debug("Received message from iFrame:", data);
                    switch (data.type) {
                        case 'state-dump':
                            debug("Received state dump from Service Worker:", data);
                            if (data.state) {
                                resolve();
                                ctx.updateState(data.state);
                            } else {
                                warn("Received empty state dump from Service Worker, ignoring.");
                            }
                            break;
                        case 'error':
                            reject(new Error(data.message || "Unknown error"));
                            break
                        default:
                            warn("Unknown IPC message from ServiceWorker:", data);
                            break;
                    }
                }
                channel.port1.onmessageerror = (err) => {
                    error("channel.port1 error:", err);
                }
                iframe!.contentWindow!.postMessage(
                    {type: '_⛨-init', version: IPC_VERSION, config: exportConfig().toString()},
                    origin,
                    [channel.port2]
                );
            }
            const unlisten = ctx.onChanges('state', (k) => {
                state = k[0].value as IStateStorage['state']
            })
            iframe.onerror = (err) => {
                unlisten();
                warn("Failed to load iframe (most likely because of Content Security Policy).", err);
                reject(new Error("Failed to load iframe (most likely because of Content Security Policy)."));
            }
            document.body.appendChild(iframe);
        })
    } catch (err) {
        if (iframe) {
            iframe.remove()
            iframe = undefined
        }
        throw err;
    }
}

export async function requestValidation() {
    channel?.port1.postMessage({type: 'request-validation'});
    await later(10_000)
    while (state !== 'solved' && state !== 'error') {
        // send a message to the Service Worker every 10 seconds to keep the Service Worker running
        channel?.port1.postMessage({type: 'request-validation'});
        await later(10_000)
    }
}

export function bfCacheRestore() {
    debug("bfcache restore detected, loading iframe again.");
    iframe?.contentWindow?.location.reload();
}

export function onpagehide() {
}